import { TenantDetailsFormData } from './data/TenantDetailsFormData';
import { TenantDetailsFormState } from './state/TenantDetailsFormState';

export class TenantDetailsForm {
    data: TenantDetailsFormData = new TenantDetailsFormData();
    state: TenantDetailsFormState = new TenantDetailsFormState();
    doValidation: boolean = false;
}
